export default "__VITE_ASSET__8cc57ace__"